import {takeEvery} from 'redux-saga/effects'
import {
  ASSIGN_PERMISSIONS,
  BULK_DELETE_STAFF_ROLES,
  CREATE_STAFF_ROLE,
  DELETE_STAFF_ROLE,
  DELETE_STAFF_ROLE_CLEANUP,
  GENERATE_STAFF_ROLE_PERMISSION_REPORT,
  GET_ASSIGN_PERMISSIONS,
  GET_STAFF_ROLE,
  GET_STAFF_ROLES,
  GET_STAFF_ROLE_CLEANUP,
  UPDATE_STAFF_ROLE,
} from 'setup/redux/Actions/StaffRole/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_STAFF_ROLES, fetchData)
  yield takeEvery(GET_STAFF_ROLE, fetchData)
  yield takeEvery(CREATE_STAFF_ROLE, fetchData)
  yield takeEvery(UPDATE_STAFF_ROLE, fetchData)
  yield takeEvery(DELETE_STAFF_ROLE, fetchData)
  yield takeEvery(BULK_DELETE_STAFF_ROLES, fetchData)
  yield takeEvery(ASSIGN_PERMISSIONS, fetchData)
  yield takeEvery(GET_ASSIGN_PERMISSIONS, fetchData)
  yield takeEvery(GENERATE_STAFF_ROLE_PERMISSION_REPORT, fetchData)
  yield takeEvery(GET_STAFF_ROLE_CLEANUP, fetchData)
  yield takeEvery(DELETE_STAFF_ROLE_CLEANUP, fetchData)
}

export default dataSaga
